import React, { useState } from "react";

const DetailWidget = ({ launch }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!launch) return null;

  const {
    name,
    status,
    launch_service_provider,
    rocket,
    mission,
    pad,
    probability,
    image,
    program,
  } = launch;

  return (
    <div className="fixed top-6 right-6 z-20 flex flex-col items-end font-orbitron">
      {/* Toggle Button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          e.currentTarget.blur(); // ✅ Prevent focus from persisting
          setIsOpen(!isOpen);
        }}
        className="bg-white text-black border border-black/20 px-4 py-2 rounded-md tracking-wider uppercase hover:border-red-500 hover:text-red-600 transition-all"
      >
        {isOpen ? "DETAILS ▶" : "DETAILS ◀"}
      </button>

      {/* Panel */}
      {isOpen && (
        <div
          className="mt-3 w-80 max-h-[85vh] overflow-y-auto p-4 bg-white text-black border border-black/10 shadow-xl rounded-2xl tracking-wide"
          onClick={(e) => e.stopPropagation()} // Optional: prevents panel click from triggering parent events
        >
          <h3 className="text-lg font-semibold mb-4 text-red-600 uppercase">{name}</h3>

          {/* Provider Logo */}
          {launch_service_provider?.logo_url && (
            <div className="flex items-center mb-3">
              <img
                src={launch_service_provider.logo_url}
                alt="Provider Logo"
                className="w-8 h-8 object-contain"
              />
            </div>
          )}

          <p className="mb-2"><strong>🚀 Rocket:</strong> {rocket?.configuration?.full_name}</p>

          {mission?.description && (
            <p className="mb-2">
              <strong>🛰️ Mission:</strong> {mission.description}
            </p>
          )}

          {mission?.orbit?.name && (
            <p className="mb-2">
              <strong>🧭 Orbit:</strong> {mission.orbit.name}
            </p>
          )}

          {pad?.name && (
            <p className="mb-2">
              <strong>📍 Pad:</strong> {pad.name}
            </p>
          )}

          {pad?.location?.name && (
            <p className="mb-2">
              <strong>🌍 Location:</strong> {pad.location.name}
            </p>
          )}

          {status?.name && (
            <p className="mb-2">
              <strong>📡 Status:</strong> {status.name}
            </p>
          )}

          {probability !== null && (
            <p className="mb-2">
              <strong>📈 Probability:</strong> {probability}%
            </p>
          )}

          {image && (
            <img
              src={image}
              alt="Mission Visual"
              className="w-full rounded mb-3"
            />
          )}

          {mission?.wiki_url && (
            <p className="mb-2">
              <a
                href={mission.wiki_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-red-600 underline hover:text-black"
              >
                🌐 Mission Wiki
              </a>
            </p>
          )}

          {program?.[0]?.info_url && (
            <p className="mb-2">
              <a
                href={program[0].info_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-red-600 underline hover:text-black"
              >
                ℹ️ Program Info
              </a>
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default DetailWidget;
